(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet-new-payment-flow.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet-new-payment-flow.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const logger = new svs.core.log.Logger('svs.sport.QuickplayModal.placeBetNewPayment');
const _svs$utils$products = svs.utils.products,
  getDisplayName = _svs$utils$products.getDisplayName,
  resolveITSProductId = _svs$utils$products.resolveITSProductId;
const isMarketplaceWallet = svs.components.tipsen.wallet.walletHelpers.isMarketplaceWallet;
const createStandardPaymentFlow = svs.components.wagerPaymentFlow.standardFlow.createStandardPaymentFlow;
const createMarketplacePaymentFlow = svs.components.wagerPaymentFlow.marketplaceFlow.createMarketplacePaymentFlow;
const _svs$components$tipse = svs.components.tipsen.wallet.walletType,
  WALLET_MARKETPLACE_PLAYER = _svs$components$tipse.WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER = _svs$components$tipse.WALLET_MARKETPLACE_RETAILER;
const groupTypes = svs.components.marketplaceData.constants.groupTypes;
const getReturnQuery = () => Object.fromEntries(new URLSearchParams(window.location.search).entries());
const executePayment = function () {
  return svs.components.wagerPaymentFlow.executePayment.executePayment(...arguments);
};
const getGroupType = type => {
  switch (type) {
    case WALLET_MARKETPLACE_PLAYER:
      return groupTypes.PRIVATE;
    case WALLET_MARKETPLACE_RETAILER:
      return groupTypes.RETAILER;
    default:
      logger.info("unsupported group type: ".concat(type));
  }
};


const createAndExecutePayment = async _ref => {
  let productId = _ref.productId,
    bag = _ref.bag,
    closeCallback = _ref.closeCallback,
    hasMarketplaceWallet = _ref.hasMarketplaceWallet,
    unlockPaymentFlow = _ref.unlockPaymentFlow,
    isPixMix = _ref.isPixMix,
    wallet = _ref.wallet,
    wagerToPay = _ref.wagerToPay,
    handleRedirect = _ref.handleRedirect,
    setKeepOpenItem = _ref.setKeepOpenItem;
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  });
  let paymentBuilder;
  const _successCallback = async () => {
    await pixHandler.fetch({
      productId,
      shouldGenerateNewPix: true
    });
    if (closeCallback) {
      closeCallback();
    }
    handleRedirect();
  };
  if (hasMarketplaceWallet) {
    const walletMeta = wallet === null || wallet === void 0 ? void 0 : wallet.meta;
    const role = getGroupType(wallet.type);
    const isC2C = Boolean(role === groupTypes.PRIVATE);
    wagerToPay.setRole(role);
    if (isC2C) {
      wagerToPay.setActivatedDrawId(walletMeta.activatedDrawId);
    } else {
      wagerToPay.setActivatedDrawId(walletMeta.activatedDrawId);
      wagerToPay.setCommissionPercent(walletMeta.commissionPercent);
    }
    paymentBuilder = createMarketplacePaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay],
      isC2C
    });
  } else {
    paymentBuilder = createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay]
    });
  }
  if (setKeepOpenItem) {
    const _pixHandler$getProduc = pixHandler.getProduct(productId),
      systemCost = _pixHandler$getProduc.systemCost,
      systemType = _pixHandler$getProduc.systemType,
      drawNumber = _pixHandler$getProduc.drawNumber,
      rowPrice = _pixHandler$getProduc.rowPrice,
      productSizes = _pixHandler$getProduc.productSizes,
      branding = _pixHandler$getProduc.branding;
    pixHandler.setKeepOpenItem({
      url: svs.utils.url.makeInternal("".concat(window.location.pathname).concat(window.location.search || '')),
      pixData: {
        productId,
        systemCost,
        systemType,
        rowPrice,
        drawNumber,
        productSizes,
        branding,
        isPixMix
      }
    });
  }
  const _await$executePayment = await executePayment(paymentBuilder, {
      userContext: {
        bag,
        returnQuery: getReturnQuery()
      }
    }),
    _await$executePayment2 = _slicedToArray(_await$executePayment, 2),
    error = _await$executePayment2[1];
  unlockPaymentFlow();
  if (!error) {
    await _successCallback();
  }
};

const placeBetNewPaymentFlow = async _ref2 => {
  let productId = _ref2.productId,
    closeCallback = _ref2.closeCallback,
    unlockPaymentFlow = _ref2.unlockPaymentFlow,
    wallet = _ref2.wallet,
    isPixMix = _ref2.isPixMix,
    handleRedirect = _ref2.handleRedirect,
    subProductId = _ref2.subProductId,
    setKeepOpenItem = _ref2.setKeepOpenItem;
  const productName = getDisplayName(productId);
  if (!productName) {
    unlockPaymentFlow();
    logger.error("Error in placeBet: Invalid productId (".concat(productId, ")"));
    return;
  }
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  });
  const _pixHandler$getProduc2 = pixHandler.getProduct(productId),
    systemCost = _pixHandler$getProduc2.systemCost;
  const bag = "".concat(systemCost, ":").concat(productName, " ").concat(systemCost);
  const wagerToPay = pixHandler.createPixWager({
    productId,
    subProductId
  });
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    logger.info('Warning in placeBetNewPaymentFlow: Sending wager without productID');
  }
  const hasMarketplaceWallet = isMarketplaceWallet(wallet);
  return createAndExecutePayment({
    productId,
    bag,
    closeCallback,
    hasMarketplaceWallet,
    unlockPaymentFlow,
    isPixMix,
    wallet,
    wagerToPay,
    handleRedirect,
    setKeepOpenItem
  });
};
setGlobal('svs.components.sport.quickplayModal.placeBet.placeBetNewPaymentFlow', placeBetNewPaymentFlow);

 })(window);